module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Medium.a6bf2cdc.woff";